import { useSelector } from 'react-redux';
import { getUserCurrency } from 'core/offers/store/selectors';

// TODO think move to offers
export const useUserCurrency = () => {
  const userCurrency = useSelector(getUserCurrency);

  return {
    currencySymbol: userCurrency.currencySymbol,
    currency: userCurrency.currency,
  };
};
